import { css } from "@emotion/react";
import trophyIcon from "../../../public/images/spinner-trophy.svg";
import Image from "next/image";

interface LoadingProps {
  open: boolean;
}

const Loading = ({ open }: LoadingProps) => {
  return (
    <div
      css={css`
        opacity: ${open ? 1 : 0};
        visibility: ${open ? "visible" : "hidden"};
        display: flex;
        transition: all 0.2s ease-in-out;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(24, 135, 201, 0.84);
        backdrop-filter: blur(5px);
        z-index: 1000;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        css={css`
          position: relative;
          width: 100px;
          height: 100px;
        `}
      >
        <div className="loader" />
        <Image
          src={trophyIcon}
          alt="Loading"
          css={css`
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          `}
        />
      </div>
      <style jsx>{`
        .loader {
          border: 3px solid rgba(255, 255, 255, 1);
          border-top: 3px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          width: 94px;
          height: 94px;
          animation: spin 1s ease-in-out infinite;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;
